import { useCallback } from 'react';

import type { ShareChannel } from 'src/app/pages/psf/share/shared/types';
import { useCurrentUserIdAsync } from 'src/app/shared/hooks/session';
import { isLoaded } from 'src/app/shared/utils/async';

export function useGetPetitionShareUrlSuffix(): (channel: ShareChannel) => string | undefined {
	const currentUserIdState = useCurrentUserIdAsync();
	const currentUserId = isLoaded(currentUserIdState) ? currentUserIdState.value : undefined;

	return useCallback(
		(channel: ShareChannel) => {
			if (channel === 'facebook') {
				return currentUserId ? `/fbog/${currentUserId}` : undefined;
			}
			return undefined;
		},
		[currentUserId],
	);
}
